import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RouteDataService } from '@services/route-data/route-data.service';
import { PrintInvoiceDialogContentComponent } from './print-invoice-dialog-content/print-invoice-dialog-content.component';

@Component({
  selector: 'app-print-invoice-dialog',
  template: ''
})
export class PrintInvoiceDialogComponent implements OnInit {

  constructor(
    public dialog: NgbModal,
    private activatedRoute: ActivatedRoute,
    private routeDataService: RouteDataService,
    private router: Router
  ) { }

  ngOnInit() {
    this.activatedRoute.paramMap.subscribe(params => {
      this.routeDataService.params = this.activatedRoute.snapshot.params;
      this.openDialog();
    });
  }

  openDialog(): void {
    var invoiceId = this.activatedRoute.snapshot.params.key;

    const dialogRef = this.dialog.open(PrintInvoiceDialogContentComponent, { centered: true, backdrop: 'static' });
    dialogRef.componentInstance.invoiceId = invoiceId;

    dialogRef.result.then((result) => {
      this.router.navigate(['../../'], { relativeTo: this.activatedRoute });
    }, (backdrop) => {
      this.router.navigate(['../../'], { relativeTo: this.activatedRoute });
    });
  }
}
